import { defineComponent } from '@digitalbranch/app'

import template from './paragraph.html'
import css from './paragraph.css'

export const uiParagraph = defineComponent({
  name: 'ui-paragraph',
  template,
  css,
})
